import React from 'react';
import styled from 'styled-components';

const FeatureBlockContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.imagePosition === 'right' ? '1fr 1fr' : '1fr 1fr'};
  gap: var(--spacing-xl);
  align-items: center;
  padding: var(--spacing-xl) 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FeatureContent = styled.div`
  order: ${props => props.imagePosition === 'right' ? 1 : 2};
  
  @media (max-width: 768px) {
    order: 2;
  }
`;

const FeatureImageContainer = styled.div`
  order: ${props => props.imagePosition === 'right' ? 2 : 1};
  
  @media (max-width: 768px) {
    order: 1;
    margin-bottom: var(--spacing-lg);
  }
  
  img {
    width: 100%;
    height: auto;
    border-radius: var(--border-radius-lg);
    box-shadow: var(--shadow-md);
  }
`;

const FeatureTitle = styled.h2`
  font-size: var(--font-size-3xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const FeatureDescription = styled.p`
  font-size: var(--font-size-lg);
  margin-bottom: var(--spacing-lg);
  color: var(--text-secondary);
  line-height: 1.6;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: var(--spacing-lg);
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--spacing-md);
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const FeatureItemIcon = styled.div`
  color: var(--primary);
  margin-right: var(--spacing-sm);
  font-size: var(--font-size-lg);
  flex-shrink: 0;
`;

const FeatureItemText = styled.div`
  flex: 1;
`;

const FeatureItemTitle = styled.h4`
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-xs);
  color: var(--text-primary);
`;

const FeatureItemDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

const FeatureActions = styled.div`
  display: flex;
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const FeatureBlock = ({
  title,
  description,
  image,
  imageAlt = 'Feature image',
  imagePosition = 'right',
  features = [],
  actions
}) => {
  return (
    <FeatureBlockContainer imagePosition={imagePosition}>
      <FeatureContent imagePosition={imagePosition}>
        <FeatureTitle>{title}</FeatureTitle>
        <FeatureDescription>{description}</FeatureDescription>
        
        {features.length > 0 && (
          <FeatureList>
            {features.map((feature, index) => (
              <FeatureItem key={index}>
                <FeatureItemIcon>
                  {feature.icon || '✓'}
                </FeatureItemIcon>
                <FeatureItemText>
                  <FeatureItemTitle>{feature.title}</FeatureItemTitle>
                  {feature.description && (
                    <FeatureItemDescription>{feature.description}</FeatureItemDescription>
                  )}
                </FeatureItemText>
              </FeatureItem>
            ))}
          </FeatureList>
        )}
        
        {actions && <FeatureActions>{actions}</FeatureActions>}
      </FeatureContent>
      
      <FeatureImageContainer imagePosition={imagePosition}>
        <img src={image} alt={imageAlt} />
      </FeatureImageContainer>
    </FeatureBlockContainer>
  );
};

export default FeatureBlock;
